import { useEffect } from 'react'

const SELECTOR = "link[rel*='icon']"

const RED_DOT_FAVICON =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><circle cx="16" cy="16" r="10" fill="%23E03131"/></svg>'.replace(
      '%23',
      '#'
    )
  )

const findOrCreateLink = (): HTMLLinkElement => {
  const existing = document.querySelector<HTMLLinkElement>(SELECTOR)
  if (existing) return existing
  const link = document.createElement('link')
  link.rel = 'icon'
  document.head.appendChild(link)
  return link
}

// 録音中に favicon を赤● にする。停止/破棄で元に戻す。
export const useRecordingFavicon = (recording: boolean) => {
  useEffect(() => {
    if (!recording) return
    const link = findOrCreateLink()
    const original = link.href
    link.href = RED_DOT_FAVICON
    return () => {
      link.href = original
    }
  }, [recording])
}
